module.exports = __webpack_public_path__ + "img/tup.35b508e8.png";